module.exports = __webpack_public_path__ + "img/nav-right-with-contact-nissan.54cf97c5.png";